import { render } from "./rectangleColorIcon.vue?vue&type=template&id=8d4384c2"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/rectangleColorIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d4384c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d4384c2', __exports__)) {
    api.reload('8d4384c2', __exports__)
  }
  
  module.hot.accept("./rectangleColorIcon.vue?vue&type=template&id=8d4384c2", () => {
    api.rerender('8d4384c2', render)
  })

}


export default __exports__